
/**
 * Cache to register general_document_types
 * @kind cache
 * @class
 * @description Custom lookup cache for GeneralDocumentTypes
 * @usage let lookup = await Grape.cache.get('ContractTypeLookup');
 */
export default {
	name: 'GeneralDocumentTypes',
	options: {
		schema: 'public',
		table: 'general_document_types',
		sortfield: 'general_document_type_id'
	}
};
